import { useRef } from "react";
import { useInView } from "framer-motion";
import { ArrowDown, Check } from "lucide-react";
import "./BuyerJourney.css";

const moments = [
  { buyer: "They read your content.", action: "We publish posts and newsletters that answer their questions.", label: "Content", tone: "blue" },
  { buyer: "They request your guide.", action: "We log their interest in your CRM and follow up.", label: "Interest", tone: "blue" },
  { buyer: "They say “not now”.", action: "Useful emails, case studies and personal mail keep you in mind.", label: "Follow-up", tone: "orange" },
  { buyer: "They return with questions.", action: "Your rep gets the full history and picks up the conversation.", label: "Sales", tone: "blue" },
  { buyer: "They become a customer.", action: "We handle the proposal and negotiation through to payment.", label: "Payment", tone: "blue" },
];

export const BuyerJourney = () => {
  const ref = useRef(null);
  const entered = useInView(ref, { once: true, amount: .15 });
  return (
    <div className="buyer-journey" data-testid="buyer-journey">
      <div className="story-shell buyer-journey-layout">
        <div className="buyer-journey-intro">
          <p className="story-eyebrow">Content + sales</p>
          <h2 className="story-title font-display">Turn “not now” into <span className="font-editorial italic text-cobalt">your next sale.</span></h2>
          <p className="story-intro">Good prospects take time. We keep them interested with content and follow up when they're ready to talk.</p>
        </div>
        <div className="buyer-journey-example">
          <p className="story-eyebrow buyer-journey-caption">Example buyer journey</p>
          <ol ref={ref} className="buyer-journey-trail" data-entered={entered}>
            {moments.map((moment, index) => (
              <li key={moment.label} data-tone={moment.tone} style={{ "--journey-delay": `${index * 170}ms` }}>
                <span className="buyer-journey-node" aria-hidden="true">{index === moments.length - 1 ? <Check size={21} /> : <ArrowDown size={21} />}</span>
                <div>
                  <p className="buyer-journey-label">{moment.label}</p>
                  <h3 className="font-display">{moment.buyer}</h3>
                  <p className="buyer-journey-action">{moment.action}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  );
};
